import { FormEvent, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { resolveImageUrl } from "../../utils/ImageUrl";
import { usePublicSiteData } from "./PublicSiteContext";

const PublicFooter = () => {
  const { slug } = useParams<{ slug: string }>();
  const website = usePublicSiteData();
  const org = website?.organization;
  const base = `/${slug ?? ""}`;

  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);

  const quickLinks = [
    { label: "Home", to: "" },
    { label: "Services", to: "services" },
    { label: "About Us", to: "about-us" },
    { label: "Contact", to: "contact" },
  ];

  const socials = (
    [
      { label: "Facebook", url: org?.facebookUrl },
      { label: "Instagram", url: org?.instagramUrl },
      { label: "YouTube", url: org?.youtubeUrl },
      { label: "LinkedIn", url: org?.linkedinUrl },
      { label: "TikTok", url: org?.tiktokUrl },
    ] as { label: string; url?: string | null }[]
  ).filter((s): s is { label: string; url: string } => Boolean(s.url));

  const handleSubscribe = (e: FormEvent) => {
    e.preventDefault();
    if (email.trim()) setSubscribed(true);
  };

  return (
    <footer className="psite-footer">
      <div className="psite-footer__grid">
        <div className="psite-footer__col">
          {org?.logoUrl ? (
            <img
              className="psite-footer__logo"
              src={resolveImageUrl(org.logoUrl)}
              alt={org.name}
            />
          ) : (
            <span className="psite-footer__brand">{org?.name ?? "Clinic"}</span>
          )}
          <p>{org?.tagline}</p>
        </div>

        <div className="psite-footer__col">
          <h4>Quick Links</h4>
          {quickLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to === "" ? base : `${base}/${link.to}`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div className="psite-footer__col">
          <h4>About</h4>
          <p>{org?.name}</p>
          <p>{org?.tagline}</p>
        </div>

        {socials.length > 0 && (
          <div className="psite-footer__col">
            <h4>Follow Us</h4>
            {socials.map((social) => (
              <a
                key={social.label}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {social.label}
              </a>
            ))}
          </div>
        )}

        <div className="psite-footer__col">
          <h4>Newsletter</h4>
          {subscribed ? (
            <p>Thank you for subscribing!</p>
          ) : (
            <form className="psite-newsletter" onSubmit={handleSubscribe}>
              <input
                type="email"
                placeholder="Your email"
                aria-label="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <button
                type="submit"
                className="psite-btn psite-btn--primary"
              >
                Subscribe
              </button>
            </form>
          )}
        </div>
      </div>

      <div className="psite-footer__bottom">
        © {new Date().getFullYear()} {org?.name ?? "Clinic"}. All rights
        reserved.
      </div>
    </footer>
  );
};

export default PublicFooter;
